import '../../../../methods/async_job.js.coffee'

Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.DashboardResultsView extends Backbone.View
  events:
    'click #export_excel': '_exportExcel'
    'click #export_tweets_metrics_excel': '_exportTweetsMetricsExcel'
    'click #export_actions_excel': '_exportActionsExcel'
    'click #export_json': '_exportJson'
    'click #social_users_export_excel': '_socialUsersExportExcel'
    'click #massive_tagging': '_massiveTagging'
    'click #export_word': '_exportWord'
    'click #massive_update': 'massiveUpdate'
    'click .refresh-dashboard': '_refresh'
    'click .exportable-fields-option': '_showExportableFieldsOption'
    'click #reprocess_contents': '_reprocessContents'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @currentUser = @options.currentUser
    @accountSettings = @options.accountSettings
    @customerData = @options.customerData
    @realtimeContentCheckerView = destroy: ->
    @RETRIES_FOR_TIMEOUT = 2
    @eventAggregator.bind('filterApplied', (count) => @contentsCount = count)

  download: (event) =>
    $(event.currentTarget).hide()
    @$el.find('#export').show()

  _exportExcel: =>
    @_exportData('export_excel', I18n.t('monitoring.dashboard.actions.export.error'), @$el.find('#results-count').text())

  _exportTweetsMetricsExcel: =>
    @_exportData(
      'export_tweets_metrics_excel',
      I18n.t('monitoring.dashboard.actions.export.error'),
      @$el.find('#results-count').text(),
      I18n.t('monitoring.dashboard.actions.export.tweets_metrics_limit', limit: 5000)
    )

  _exportActionsExcel: =>
    @_exportData('export_actions_excel', I18n.t('monitoring.dashboard.actions.export.error'), @$el.find('#results-count').text())

  _exportJson: =>
    @_exportData('export_json', I18n.t('monitoring.dashboard.actions.export.error'), @$el.find('#results-count').text())

  _socialUsersExportExcel: (event) =>
    event.stopPropagation()
    @contentExporter = new Process.Methods.ContentExporter({
      actionContainer: @$el.find('#social_users_export_excel'),
      exportableFieldsContainer: @$el.find('#container-exportable-field'),
      searchQuery: @searchQuery.toJSON(),
      uniqueUsers: @unique_users
      totalContents: @totalComments
    })
    @contentExporter.exportProfiles()

  user_profile_attributes_to_hash: (custom_atributes)=>
    h = {}
    for atr, i in custom_atributes
      index = i
      index = index.toString()
      h[index] = custom_atributes[i]
    h

  _translateDefaultExportableFields: (exportable_fields_hash)=>
    for key in Object.keys(exportable_fields_hash)
      @exportable_fields_hash[key] = I18n.t('monitoring.exportable_fields.social_user.' + exportable_fields_hash[key])


  _exportantionConfirmed: =>
    @_export('social_users_export_excel', I18n.t('monitoring.dashboard.actions.export.error'), @unique_users)

  _jsonexportantionConfirmed: =>
    @_export('social_users_export_json', I18n.t('monitoring.dashboard.actions.export.error'), @unique_users)

  _exportWord: =>
    this._exportData('export_word', "There is no news to export, maybe you are not filtering by 'Clipping'", @contentsCount)

  _exportData: (action, message, contentsCount, title) =>
    $button = @$el.find('#'+action)
    return if $button.hasClass('disabled')
    @_showExportationSwal($button, action, message, contentsCount, title)

  _showExportationSwal: ($button, action, message, contentsCount, title) ->
    title ||= I18n.t('monitoring.dashboard.actions.export.count', count: contentsCount)
    text = if contentsCount >= 50000 then I18n.t('monitoring.dashboard.actions.export.limit', limit: '50.000') else ''
    swal({
      title: title,
      text: "#{text}",
      type: 'info',
      showCancelButton: true,
      cancelButtonText: I18n.t('monitoring.dashboard.actions.export.cancel'),
      confirmButtonText: I18n.t('monitoring.dashboard.actions.export.confirm'),
      closeOnConfirm: false
    }, (isConfirm) =>
      if (isConfirm)
        @_startExportation($button, action, message, @searchQuery.toJSON())
        swal(
          I18n.t('monitoring.dashboard.actions.export.started'),
          I18n.t('monitoring.dashboard.actions.export.message_with_approval'),
          'info'
        )
    )

  _startExportation: ($button, action, message, params) =>
    exportJob = new Monitoring.Methods.AsyncJob()
    exportJob.bind('completed', (results) => @_onComplete($button, results))
    exportJob.bind('failed', (results) => @_onFailure($button, message))
    exportJob.start action, params

  _onComplete: ($button, results) =>
    if !results.hasOwnProperty('auto_download') || results.auto_download
      window.open(results.path, '_blank');

  _onFailure: ($button, message) =>
    $button.button('reset').text('Export failed, retry?').addClass('warning')
    showError(message)

  _massiveTagging: =>
    @massiveTagging.show()

  massiveUpdate: =>
    @massiveUpdate.show()

  _reprocessContents: =>
    @reprocessContents.contentsTotal = @totalComments
    @reprocessContents.show()

  destroy: ->
    @realtimeContentCheckerView.destroy()
    @remove()

  render: ->
    @massiveUpdate      = new Monitoring.Views.Dashboards.MassiveUpdateView({searchQuery: @searchQuery})
    @massiveTagging     = new MassiveTagging.Views.MassiveTaggingView
      searchQuery: @searchQuery
      updateJobClass: Monitoring.Methods.AsyncJob
    @reprocessContents  = new Monitoring.Views.Dashboards.ReprocessView({searchQuery: @searchQuery, currentUser: @currentUser})
    @massiveUpdate.setOnFinish =>
      document.body.style.cursor = 'default'
      @massiveUpdate.hide()
      @newSearch()
      @render()
    @$el.html(@template(accountSettings: @accountSettings, order: @searchQuery.get('order')))
    @$el.append(@massiveUpdate.render().el)
    @$el.append(@massiveTagging.render().el)
    @$el.append(@reprocessContents.render().el)
    @massiveUpdate.hide(false)
    @$resultsContainer = @$el.find('#current_results')
    @$previousResultsContainer = @$el.find('#previous_results')
    return this

  newSearch: (searchQueryChanged=false, forNewMyHistorySession=false) ->
    @$el.find('#post-selector').hide()
    @searchQuery.set('search_query_changed', searchQueryChanged)
    @searchQuery.resetCounter()
    @searchQuery.set('sessionMinimized', true) if forNewMyHistorySession
    @searchWith(@defaultSearchMethod, true)

  searchWith: (methodName, new_search, callback, retries=@RETRIES_FOR_TIMEOUT) ->
    if new_search
      @trigger('searchStarted')
    onBeforeSend = () =>
      NProgress.start()
    onSuccess = (dashboardResults) =>
      if dashboardResults.error
        if retries > 0
          @_handleErrors(dashboardResults, methodName, new_search, callback, retries)
        else
          window.showError(I18n.t('monitoring.dashboard.invalid_query.error'))
          @trigger('searchCompleted', {})
          NProgress.done()
      else
        @last_search_contents_taken = (dashboardResults.values.length || 0) if @isReviewQuery()
        @massiveUpdate.setReachedDocument(dashboardResults.total) if dashboardResults.total and @massiveUpdate.setReachedDocument
        @massiveTagging.setReachedDocument(dashboardResults.total) if dashboardResults.total and @massiveUpdate.setReachedDocument
        @_updateMassiveUpdateContent(dashboardResults) if new_search
        @realtimeContentCheckerView.setBatchSize(@last_search_contents_taken) if @isReviewQuery() and @realtimeContentCheckerView.setBatchSize
        callback = callback || @handleQueryResults
        callback(dashboardResults, new_search)
        NProgress.done()
        @trigger('totalChanges', dashboardResults) if new_search
        # showing more results is not considered a change in the current session, unlike adding or removing filters.
        # the number of showed results is not saved in the session anyway
        @_changeSession(dashboardResults.session) unless (methodName == 'next' or methodName == 'done')
    onError = (response) =>
      @_handleErrors(response, methodName, new_search, callback, retries)
    @_doPostRequest(methodName, onSuccess, onError, onBeforeSend)

  _changeSession: (newSession) ->
    @trigger('changeSession', newSession)

  _handleErrors: (response, methodName, new_search, callback, retries) ->
    if response.error && response.exception == 'BadRequest'
      swal({
        title: I18n.t('monitoring.dashboard.invalid_query.title'),
        type: 'error',
        confirmButtonClass: 'btn-danger',
        confirmButtonText: I18n.t('monitoring.dashboard.invalid_query.confirm'),
        closeOnConfirm: true
      }, (isConfirm) =>
        NProgress.done()
        @trigger('restoreFromServer')
      )
    else if response.status == 401
      NProgress.done()
      @trigger('restoreFromServer')
    else if response.error && response.exception && response.exception.startsWith('date_since is higher than date_until')
      window.showError(I18n.t('monitoring.dashboard.invalid_query_dates'))
      @trigger('searchCompleted', {})
      NProgress.done()
    else if retries > 0
      @searchWith(methodName, new_search, callback, retries - 1)

  _updateMassiveUpdateContent: (dashboardResults) ->
    contextTags = []
    _.each(Keepcon.tags, (tags) -> contextTags = contextTags.concat(tags))
    @massiveUpdate.setTopicsActions(Keepcon.topics)
    @massiveUpdate.setAddTags(_.uniq(contextTags, (tag) -> return tag.code))

    tags = []
    if dashboardResults.facets
      facets = _.map(dashboardResults.facets.tag.terms, (term) -> term.term)
      tags = _.map(facets, (facet) ->
        _.find(contextTags, (contextTag) -> contextTag.code == facet))

      @massiveUpdate.setRemoveGroups(_.map(dashboardResults.facets.label.terms, (term) -> term.term))
      @massiveUpdate.setAddGroups(Keepcon.groups)
    @massiveUpdate.setRemoveTags(_.without(tags, undefined))

  _doPostRequest: (methodName, onSuccess, onError, onBeforeSend) =>
    # the following 3 lines are for debugging purposes.
    data = @searchQuery.toJSON()
    total_results = @$el.find('#results-count').text()
    data.total_results = total_results if methodName == 'next' && total_results != ""
    $.ajax(
      type: 'POST',
      url: "/monitoring/dashboard/#{methodName}/",
      data: data,
      global: false,
      beforeSend: onBeforeSend,
      success: onSuccess,
      error: onError)

  handleQueryResults: (dashboardResults, new_search, container) =>
    # console.log(
    #   "ElasticSearch time #{dashboardResults.elasticsearch_time} ms. - " +
    #     "Cassandra time #{dashboardResults.cassandra_time} ms. - " +
    #     "Total time #{dashboardResults.total_time} ms.")

    @searchQuery.complete()

    if dashboardResults.values.length == 0
      @showNoResultsMessage(new_search)
    else
      @clearNoResultsMessage()
    @onResultsCount(dashboardResults.values.length) if @onResultsCount

    if new_search
      @$resultsContainer.empty()
      @$previousResultsContainer.empty()
      @trigger('searchCompleted', dashboardResults)
      @realtimeContentCheckerView.destroy()
      @realtimeContentCheckerView = @createRealtimeView()
      @$el.find('#new_content_available').append(@realtimeContentCheckerView.render().el)
      @$el.find('#download').hide()
      @$el.find('#export').show()

    _.each(dashboardResults.values, (content) => @addOneToTheEnd(content, Keepcon.tags, container))
    if dashboardResults.total >= 0
      @showTotalResults(dashboardResults.total)
      @saveTotalComments(dashboardResults.total)
    @unique_users = dashboardResults.unique_users
    @$el.find('#unique-users-count').html(I18n.formatNumber(dashboardResults.unique_users,{precision: 0})) if dashboardResults.unique_users >= 0

  showTotalResults: (total) =>
    @$el.find('#results-count').html(I18n.formatNumber(total,{precision: 0}))

  saveTotalComments: (total) =>
    @totalComments = total

  showNoResultsMessage: (new_search) ->
    @$el.find('#previous_results_link').hide()
    if new_search
      @$el.find('#no_results').removeClass('hide')
      @$el.parents('#results_container').find('.show-charts').hide()

  clearNoResultsMessage: ->
    @$el.find('#previous_results_link').show()
    @$el.find('#no_results').addClass('hide')
    @$el.parents('#results_container').find('.show-charts').show()

  addOneToTheEnd: (socialContent, allTags, container=@$resultsContainer) =>
    @addOne(socialContent, allTags, (element) =>  container.append(element))

  addAndApplyEffect: (view, addFunction) ->
    view.bind('updateResultCount', @updateResultCount)
    element = view.render().$el
    element.hide()
    addFunction(element)
    element.fadeIn(
      done: ()-> Backbone.trigger('contents:finishedLoading')
    )


  createRealtimeView: () ->
    new Monitoring.Views.SocialContents.RealtimeContentCheckerView(uuid: @searchQuery.get('uuid'))

  updateResultCount: (delta) =>
    resultsCount = @$el.find('#results-count')
    newResult = parseInt(resultsCount.text().match(/\d+/g)) + delta
    newResult = if newResult < 0 then 0 else newResult
    resultsCount.html(newResult)
    @trigger('onReviewCountUpdated', newResult)

  postSelectionPending: ->
    @searchQuery.get('analysisMode') and not @searchQuery.hasSelectedPosts()

  _refresh: =>
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  isReviewQuery: =>
    return false

  doGetUserProfileAttributes: =>
    $.ajax
      type: 'GET'
      url: '/keepcon/settings/user_profile_attributes/availables_attributes'
      async: false
      success: (response) =>
        if response.success
          @user_profile_attributes = (response.user_profile_attributes || []).concat(['tags'])

  createFilterView: (searchQuery, dashboardResults, topics, channels) ->
    new Monitoring.Views.SocialContents.Filters.FiltersView({
      searchQuery: searchQuery,
      facets: dashboardResults.facets,
      postFacets: dashboardResults.post_facets,
      topics: topics,
      tagsByClientCode: dashboardResults.tags_by_client_code,
      searchMethod: @defaultSearchMethod,
      isReplyFilter: dashboardResults.is_reply_filter,
      sortedAvailableChannelsByProvider: channels
    })

  createChartsView: (searchQuery, dashboardResults, sessionSharingData) ->
    new Monitoring.Views.DashboardChartsView
      searchQuery: searchQuery
      facets: dashboardResults.facets
      eventList: dashboardResults.events
      totalCount: dashboardResults.total
      uniqueUsersCount: dashboardResults.unique_users
      tagsByClientCode: dashboardResults.tags_by_client_code
      taxonomiesCodes: dashboardResults.taxonomies_codes
      sessionSharingData: sessionSharingData
      submodesPermissions: @options.submodesPermissions
